import { render, staticRenderFns } from "./Soluciones.vue?vue&type=template&id=5a09ce2f&scoped=true"
import script from "./Soluciones.vue?vue&type=script&lang=js"
export * from "./Soluciones.vue?vue&type=script&lang=js"
import style0 from "./Soluciones.vue?vue&type=style&index=0&id=5a09ce2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09ce2f",
  null
  
)

export default component.exports